import type { TenantConfig } from '@/types/TenantConfig'

const purple = '#6f3a77'
const green = '#b9d646'
const orange = '#fb7702'
const lightPurple = '#e8d2ea'
const darkPurple = '#8a7e8d'

export const fearcolumbus: TenantConfig = {
  logo: 'assets/fearcolumbus/static/logo.png',
  themeOptions: {
    primaryColor: orange,
    secondaryColor: purple,
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    cartHeaderBackgroundColor: 'black',
    memberLinksColor: lightPurple,
    memberLinksColorHover: darkPurple,
    logoHeight: '80px',
    headerHeight: '120px',
    headerBackground: 'black',
  },
}
